import { Application, Controller } from 'stimulus'
import Chart from 'chart.js'

const app = Application.start()

app.register('bar-chart', class extends Controller {
  connect () {
    new Chart(this.element, {
      type: 'bar',
      data: this.barChartData(),
      options: this.barChartOptions(),
    })
  }

  barChartData () {
    return JSON.parse(this.element.dataset.barChartData)
  }

  barChartOptions () {
    return JSON.parse(this.element.dataset.barChartOptions)
  }
})
